import View from "./View.js";
import icons from "url:../../img/BBA25-sprite.svg"; // Parcel 2

class PreviewView extends View {
	_parentElement = "";

	_generateMarkup() {
		const descriptionMarkup = this._data.description
			? `<div class="product__decription">${this._data.description}</div>`
			: "";
		const finalistMedal = this._data.finalist
			? `
				<div class="medal medal--final">
					<div class="medal__title">Finālists</div>
					<svg class="medal__decoration">
					<use href="${icons}#medal-decoration"></use>
					</svg>
					<svg class="medal__brand">
					<use href="${icons}#medal_title"></use>
					</svg>
				</div>
				`
			: "";

		return `
		<a href="https://www.bt1.lv/balticbeauty/read.php?subid=${this._data.id}" class="product">
			<div class="product__img product__img--bondi-blue">
			<img src="https://www.bt1.lv/bt1/zina_baze/images/thumbs/${this._data.imgFile}" alt="${this._data.title}" class="product-image" />
			${finalistMedal}
			</div>
			<div class="product__title">
			<div class="product__heading">${this._data.title}</div>
			${descriptionMarkup}
			</div>
		</a>
		`;

		// createImageMarkup(this._data);

		// console.log(this._ext);
	}
}

export default new PreviewView();
